import { LocalizationModule } from '@abp/ng.core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { AchievementsCelebrationDialogComponent } from './achievements-celebration/achievements-celebration-dialog.component';
import { AchievementsRevokedDialogComponent } from './achievements-revoked/achievements-revoked-dialog.component';
import { AchievementsWelcomeDialogComponent } from './achievements-welcome/achievements-welcome-dialog.component';
import { BadgeTileComponent } from './badge-tile/badge-tile.component';

/**
 * Presentational badge pieces shared by the profile module and the app root (welcome,
 * celebration and revoked dialogs).
 */
@NgModule({
  declarations: [
    BadgeTileComponent,
    AchievementsWelcomeDialogComponent,
    AchievementsCelebrationDialogComponent,
    AchievementsRevokedDialogComponent,
  ],
  imports: [CommonModule, LocalizationModule, MatDialogModule],
  exports: [
    BadgeTileComponent,
    AchievementsWelcomeDialogComponent,
    AchievementsCelebrationDialogComponent,
    AchievementsRevokedDialogComponent,
  ],
})
export class BadgesModule {}
